import * as schemas from "~/schemas/schema.reminders.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchReminders = (parentId, parentType) => {
  if (!parentId || !parentType) {
    return { type: actionTypes.FETCH_REMINDERS_ERROR };
  }

  const slug = Angie.functions.slug(parentType);
  const url = `${Angie.api_url}/reminders/${slug}/${parentId}`;
  return {
    types: [
      actionTypes.FETCH_REMINDERS_LOADING,
      actionTypes.FETCH_REMINDERS_SUCCESS,
      actionTypes.FETCH_REMINDERS_ERROR,
    ],
    callAPI: () => fetch({ url: url }),
    payload: {
      parentId,
      parentType,
      schema: schemas.arrayOfReminders,
    },
    cache: {
      key: url,
    },
  };
};

export const addReminder = (parentId, parentType, attributes) => {
  const slug = Angie.functions.slug(parentType);

  return {
    types: [actionTypes.ADD_REMINDER_LOADING, actionTypes.ADD_REMINDER_SUCCESS, actionTypes.ADD_REMINDER_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/reminders/${slug}/${parentId}`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      parentId,
      parentType,
      attributes,
      schema: {
        single: schemas.reminder,
      },
    },
  };
};

export const editReminder = (id, attributes) => {
  return {
    types: [actionTypes.EDIT_REMINDER_LOADING, actionTypes.EDIT_REMINDER_SUCCESS, actionTypes.EDIT_REMINDER_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/reminders/${id}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      id,
      attributes,
      schema: {
        single: schemas.reminder,
      },
    },
  };
};

export const deleteReminder = (id) => {
  return {
    types: [
      actionTypes.DELETE_REMINDER_LOADING,
      actionTypes.DELETE_REMINDER_SUCCESS,
      actionTypes.DELETE_REMINDER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/reminders/${id}`,
        method: `DELETE`,
      }),
    payload: {
      id,
    },
  };
};

export const addReminderFromEventStream = (data) => {
  return {
    type: actionTypes.ADD_REMINDER_FROM_EVENT_STREAM,
    response: data,
    schema: schemas.reminder,
  };
};

export const updateReminderFromEventStream = (data) => {
  return {
    type: actionTypes.UPDATE_REMINDER_FROM_EVENT_STREAM,
    response: data,
    schema: schemas.reminder,
  };
};

export const deleteReminderFromEventStream = (data) => {
  return {
    type: actionTypes.DELETE_REMINDER_FROM_EVENT_STREAM,
    id: data.id,
  };
};
